<template>
  <v-container class="new-access-key-page" fluid>
    <v-breadcrumbs :items="items" class="px-0 pt-0 pb-2" />
    <div class="new-access-key-page__header">
      <h1 class="new-access-key-page__title">{{ $route.meta.title }}</h1>
      <v-btn
        text
        class="text-none"
        color="primary"
        :to="listLocation"
      >
        <v-icon left small>mdi-arrow-left</v-icon>
        К списку ключей
      </v-btn>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card class="new-access-key-page__card" flat outlined>
        <div class="new-access-key-page__section new-access-key-page__section--data">
          <div class="new-access-key-page__section-title">
            <v-icon left small>mdi-key-variant</v-icon>
            Данные ключа
          </div>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                ref="codeKey"
                v-model="codeKey"
                prepend-inner-icon="mdi-key-outline"
                label="Код ключа"
                outlined
                dense
                :rules="[
                  () => !!codeKey || 'Обязательное поле',
                  () => /^[0-9A-F]{5,}$/.test(codeKey) || 'Минимум 5 символов: только цифры и заглавные буквы A–F',
                  () => !/^0+$/.test(codeKey) || 'Код не может состоять только из нулей',
                  () => !/^0000/.test(codeKey) || 'Код не может начинаться с четырех нулей',
                ]"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                ref="nameKey"
                v-model="nameKey"
                prepend-inner-icon="mdi-rename-box-outline"
                label="Название ключа"
                outlined
                dense
                :maxlength="64"
                counter="64"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="selectedType"
                :items="typeKey"
                item-value="id"
                item-text="value"
                prepend-inner-icon="mdi-alert-circle-outline"
                label="Тип ключа"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col v-if="roleName !== 'agent'" cols="12" sm="6" md="4">
              <v-autocomplete
                ref="agent"
                v-model="agent"
                label="Агент"
                :items="organizations"
                item-text="user.name"
                item-value="id"
                prepend-inner-icon="mdi-account-search"
                :rules="[() => !!agent || 'Обязательное поле']"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" md="8">
              <v-textarea
                v-model="comment"
                label="Комментарий"
                outlined
                dense
                rows="2"
                clearable
                prepend-inner-icon="mdi-comment-outline"
                auto-grow
                hide-details
              />
            </v-col>
          </v-row>
        </div>

        <v-divider class="my-0" />

        <div class="new-access-key-page__section">
          <div class="new-access-key-page__section-title">
            <v-icon left small>mdi-nfc</v-icon>
            Считыватели
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <div class="new-access-key-page__reader-block">
                <div class="new-access-key-page__reader-title">Внутренний считыватель</div>
                <div class="new-access-key-page__reader-checkboxes">
                  <v-checkbox v-model="internal_reader" value="1" label="Замок A" hide-details color="primary" />
                  <v-checkbox v-model="internal_reader" value="2" label="Замок B" hide-details color="primary" />
                  <v-checkbox v-model="internal_reader" value="3" label="Замок C" hide-details color="primary" />
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="new-access-key-page__reader-block">
                <div class="new-access-key-page__reader-title">Внешний считыватель</div>
                <div class="new-access-key-page__reader-checkboxes">
                  <v-checkbox v-model="external_reader" value="1" label="Замок A" hide-details color="primary" />
                  <v-checkbox v-model="external_reader" value="2" label="Замок B" hide-details color="primary" />
                  <v-checkbox v-model="external_reader" value="3" label="Замок C" hide-details color="primary" />
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <v-divider class="my-0" />

        <div class="new-access-key-page__actions">
          <v-btn
            color="primary"
            class="text-none"
            rounded
            @click.prevent="saveChanges()"
            :disabled="!valid"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            Сохранить
          </v-btn>
          <v-btn
            color="primary"
            outlined
            class="text-none"
            dark
            rounded
            @click.prevent="readKey()"
          >
            <v-icon left>mdi-nfc</v-icon>
            Считать
          </v-btn>
          <v-btn
            text
            class="text-none"
            @click.prevent="returnAccessKeys()"
          >
            Отменить
          </v-btn>
        </div>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  TAB_SIMPLE,
  TAB_UNIVERSAL,
  accessKeysListLocation,
  buildAccessKeysListQuery,
  parseAccessKeysListQuery,
} from '@/components/accessKeys/accessKeysListRoute';

export default {
  name: 'NewAccessKey',
  props: ['id'],
  data () {
    return {
      valid: true,
      codeKey: '',
      nameKey: '',
      comment: '',
      agent: '',
      typeKey: [
        {
          id: 0,
          value: 'Неуниверсальный',
        },
        {
          id: 1,
          value: 'Универсальный',
        },
      ],
      selectedType: 0,
      internal_reader: ['1'],
      external_reader: ['2'],
      popupKeyReader: false,
    };
  },
  created () {
    const { tab } = parseAccessKeysListQuery(this.$route.query);
    this.selectedType = tab === TAB_UNIVERSAL ? 1 : 0;
  },
  computed: {
    ...mapGetters({
      organizations: 'Agents/agents',
      roleName: 'roleName',
    }),
    listLocation () {
      return accessKeysListLocation(this.$route.query);
    },
    items () {
      return [
        {
          text: 'Ключи доступа',
          disabled: false,
          to: this.listLocation,
        },
        {
          text: 'Новый ключ доступа',
          disabled: true,
          href: '#',
        },
      ];
    },
    form () {
      if (this.roleName !== 'agent') {
        return {
          codeKey: this.codeKey,
          nameKey: this.nameKey,
          agent: this.agent,
        };
      } else {
        return {
          nameKey: this.nameKey,
          codeKey: this.codeKey,
        };
      }
    },
    formErrors () {
      let resultError = false;

      for (const key in this.$refs) {
        if (this.$refs[key].hasError) {
          resultError = true;
        }
      }

      return resultError;
    },
  },
  methods: {
    ...mapActions({
      newKey: 'Keys/newKey',
      loadAllAgents: 'Agents/loadAllAgents',
      toReadKey: 'Keys/readKey',
    }),
    saveChanges () {
      Object.keys(this.form).forEach(f => {
        this.$refs[f].validate(true);
      });

      this.$nextTick(() => {
        if (!this.formErrors) {
          let dataKey;
          if (this.roleName !== 'agent') {
            dataKey = {
              code: this.codeKey,
              universal: this.selectedType,
              agent_id: this.agent,
              comment: this.comment,
            };
          } else {
            dataKey = {
              code: this.codeKey,
              universal: this.selectedType,
              comment: this.comment,
            };
          }

          if (this.nameKey) {
            dataKey.name = this.nameKey;
          }
          // if (this.comment) {
          //   dataKey.comment = this.comment;
          // }

          const internalReaders = this.internal_reader.sort().join('');
          const externalReaders = this.external_reader.sort().join('');
          dataKey.internalReaders = (internalReaders === '') ? 0 : parseInt(internalReaders);
          dataKey.externalReaders = (externalReaders === '') ? 0 : parseInt(externalReaders);

          this.newKey(dataKey)
            .then(() => {
              this.$flash_success('Ключ успешно создан');
              const { page, perPage } = parseAccessKeysListQuery(this.$route.query);
              this.$router.push({
                name: 'Access-keys',
                query: buildAccessKeysListQuery({
                  tab: this.selectedType === 1 ? TAB_UNIVERSAL : TAB_SIMPLE,
                  page,
                  perPage,
                }),
              });
            })
            .catch((message) => {
              if (message.length > 0) {
                for (let i = 0; i < message.length; i++) {
                  this.$flash_warning(message[i]);
                }
              } else {
                this.$flash_warning('Ошибка при создании ключа');
              }
            });
        }
      });
    },
    returnAccessKeys () {
      this.$router.push(this.listLocation);
    },
    readKey () {
      this.toReadKey()
        .then((response) => {
          if (response) {
            this.codeKey = response.data;
          } else {
            this.$flash_warning('Поднесите ключ к считывателю');
          }
        })
        .catch(e => {
          this.$flash_warning('Проверьте подключение к считывателю');
          console.error(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-access-key-page {
  padding: 24px;
  max-width: 80%;
}

.new-access-key-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
}

.new-access-key-page__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.new-access-key-page__card {
  border-radius: 12px;
  overflow: hidden;
}

.new-access-key-page__section {
  padding: 20px 24px;
}

.new-access-key-page__section--data {
  padding-bottom: 16px;
}

.new-access-key-page__section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}

.new-access-key-page__reader-block {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
}

.new-access-key-page__reader-title {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #37474f;
  margin-bottom: 12px;
}

.new-access-key-page__reader-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
}

.new-access-key-page__actions {
  padding: 16px 24px 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

@media screen and (max-width: 600px) {
  .new-access-key-page__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .new-access-key-page__title {
    font-size: 1.4rem;
  }
}
</style>
